import styled from 'styled-components';

const ErrorMessage = styled.div.attrs({
  className: 'text-sm text-danger',
})`
  height: 20px;
`;

export { ErrorMessage };
